import { render } from "./Boolean.vue?vue&type=template&id=65728065&lang=pug"
import script from "./Boolean.vue?vue&type=script&lang=ts"
export * from "./Boolean.vue?vue&type=script&lang=ts"
script.render = render

export default script